const MENSAGEM_REGISTRO_DUPLICADO = "Já existe um registro cadastrado com estes dados. Verifique as informações informadas.";

export const MENSAGEM_ERRO_INESPERADO =
  "Não foi possível concluir a operação. Tente novamente em instantes e, se o problema persistir, contate o suporte.";

const PADROES_ERRO_TECNICO = [
  /Exception while fetching data/i,
  /Validation error of type/i,
  /\w+(Exception|Error)\b/,
  /\b(java|javax|br\.com|org|com)\.[\w.$]+/,
  /\n\s*at\s/,
  /Invalid (column|object) name|Incorrect syntax|Conversion failed|deadlock|The (INSERT|UPDATE|DELETE|SELECT) statement/i,
  /Cannot read propert|is not a function|Unexpected token|Internal Server Error/i,
  /^\s*(null|undefined)?\s*$/,
];

const PREFIXO_FALHA_DO_BEAN = /^Falha ao [^:]*\.:\s*/;

const ehErroTecnico = (mensagem: string) => PADROES_ERRO_TECNICO.some((padrao) => padrao.test(mensagem));

const convertMessage = (message?: string) => {
  if (!message) {
    return MENSAGEM_ERRO_INESPERADO;
  }
  let retorno = message;
  if (message.indexOf("The DELETE statement conflicted with the REFERENCE constraint") > -1) {
    retorno = "Exclusão não realizada pois há dependências do registro.";
  } else if (message.indexOf("Violation of UNIQUE KEY constraint") > -1) {
    retorno = MENSAGEM_REGISTRO_DUPLICADO;
  } else if (message.indexOf("Exception while fetching data") > -1) {
    if (message.indexOf("br.com.chart.web.jsf.beans.basic.secure.NotPermittedException") > -1) {
      const index = message.lastIndexOf(":");
      retorno = message.substring(index + 1, message.length + 1).trim();
    } else {
      const partes = message.split(" : ");
      retorno = partes.length > 1 ? partes[1].trim() : message;
    }
  }

  retorno = retorno.replace(PREFIXO_FALHA_DO_BEAN, "");
  return ehErroTecnico(retorno) ? MENSAGEM_ERRO_INESPERADO : retorno;
};

export default convertMessage;
